import { Navigate, Route, Routes } from "react-router";
import { SurveyListPage } from "./SurveyListPage";
import { SurveyQuestionsPage } from "./SurveyQuestionsPage";
import { SurveyTargetPage } from "./SurveyTargetPage";

export function SurveyRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="survey-list" replace />} />
      <Route path="survey-list" element={<SurveyListPage />} />
      <Route path=":surveyId/questions" element={<SurveyQuestionsPage />} />
      <Route path=":surveyId/targeting" element={<SurveyTargetPage />} />
      <Route path="*" element={<Navigate to="/dashboard/survey/survey-list" replace />} />
    </Routes>
  );
}
